(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm_product_carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{const KEY='dmShopEditWishlist';const read=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};const write=v=>{try{localStorage.setItem(KEY,JSON.stringify(v))}catch(e){}};function init(root){if(!root||root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('[data-track]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');const arrows=()=>{if(!track||!prev||!next)return;const max=Math.max(0,track.scrollWidth-track.clientWidth-2);prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max};const move=d=>{const card=track?.querySelector('.dm-edit__card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap||0);track.scrollBy({left:d*(card.getBoundingClientRect().width+gap),behavior:'smooth'})};prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));track?.addEventListener('scroll',arrows,{passive:true});window.addEventListener('resize',arrows);arrows();const saved=new Set(read());root.querySelectorAll('[data-heart]').forEach(b=>{const h=b.dataset.handle,i=b.querySelector('span');const paint=()=>{const on=saved.has(h);b.classList.toggle('is-saved',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',`${on?'Remove':'Save'} ${b.dataset.title||'product'}${on?' from saved items':''}`);if(i)i.textContent=on?'♥':'♡'};paint();b.addEventListener('click',()=>{saved.has(h)?saved.delete(h):saved.add(h);write([...saved]);paint()})})}const all=s=>s.querySelectorAll('[data-dm-edit]').forEach(init);document.addEventListener('DOMContentLoaded',()=>all(document));document.addEventListener('shopify:section:load',e=>all(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
